import BaseHandler from "../BaseHandler";
import { ClientJoinByUsernameResponse } from "../../proto/ClientJoinByUsername_pb";
import store from "../../store";
import { setCurrentRoomExtra, updateRoomReadOnly } from "../../store/rooms/actions";
import { getStorage } from "../../libs/storage";
import { STORAGE_CURRENT_ROOM } from "../../constants/localstorage";
import { isGroup } from "../../libs/services";

export default class HandleClientJoinByUsernameResponse extends BaseHandler<ClientJoinByUsernameResponse> {
  handle() {
    store.dispatch(setCurrentRoomExtra({ subscribed: false, notJoined: false }));

    const currentRoom = getStorage(STORAGE_CURRENT_ROOM);
    if (isGroup(currentRoom)) {
      store.dispatch(updateRoomReadOnly(currentRoom));
    }
  }
}
